module.exports = __webpack_public_path__ + "img/clean.be5030ca.webp";